export enum Routes {
	Dashboard = "/dashboard",
	BookingPlan = "/booking-plan",
	BookingPlanComposer = "/booking-plan/composer",
	BookingPlanList = "/booking-plan/list",
	InquiryList = "/inquiry-list",
	Payments = "/payments",
	PrintViews = "/printviews",
	AdminSettings = "/admin",
	Settings = "/settings"
}
